import styled from 'styled-components';

export const Form = styled.form`
  // margin: 1em;
`;

export default Form;
